import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/centripetal-force-calculator',
  component: () => import('../../routes/CentripetalForceCalculator.svelte'),
  card: {
    id: 'centripetal-force-calculator',
    title: 'Centripetal Force Calculator',
    description:
      'Calculate centripetal force, mass, velocity, or radius using Fc = mv²/r. Enter any three values to find the fourth. Includes g-force and RPM.',
    icon: 'rotate_right',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/centripetal-force-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Centripetal Force Calculator – Fc = mv²/r, with g-force',
    description:
      'Free centripetal force calculator using Fc = mv²/r. Solve for force, mass, velocity, or radius — enter any three to find the fourth. Includes period, RPM, angular velocity, and g-force readouts.',
  },
};

export default meta;
